import { NewTicketQueryParams, PaginationOptions } from 'types';

// Type and ServiceLevel
const ACCOUNT_EXCLUSION_TYPES = {
  managed_gcp: 'Runway',
  azure: 'Navigator',
};

const NONE_SELECTED = 'None Selected';

const CTUI = 'CTUI';

const NPST = 'NPS-T';

const NPS_RELATED_EVENT_TYPES = {
  process: 'process',
  device: 'device',
  ticket: 'ticket',
  invoice: 'invoice',
  notification: 'notification',
};

const NPS_RELATED_EVENT_CATEGORIES = {
  service: 'service',
  serviceBlock: 'service block',
  product: 'product',
};

const CSAT_EVENT_TYPES = {
  TICKET: 'ticket',
};

const CSAT_EVENT_CATEGORIES = {
  SERVICE: 'service',
};

const CSAT = 'CSAT';
const PILOT_DIV_ID = '#nav-pilot';

const KEVALIN_COLLECTIONS = {
  CUSTOMER_NPS: 'SERVICE.CUSTOMER.NPS',
  CTUI_PREFERENCES: 'SERVICE.CTUI.PREFS',
  CSAT: 'SERVICE.CUSTOMER.CSAT',
};

const BROWSER_NAMES = ['Edg', 'Chrome', 'MSIE', 'Firefox', 'Safari', 'Opera'];

const COLLECTIONS = {
  DEVICE_FILTER: 'DEVICE_FILTER',
  DEVICE: 'DEVICE',
  TICKETS_DEVICES: 'TICKETS_DEVICES',
  GROUP: 'GROUP',
  SEVERITY: 'SEVERITY',
  TEMPLATE: 'TEMPLATE',
  TICKET_EXPORT: 'TICKET_EXPORT',
  TICKET: 'TICKET',
  ALL_CONTACTS: 'ALL_CONTACTS',
};

const DEFAULT_NEW_TICKET_QUERYPARAMS: NewTicketQueryParams = {
  new_ticket: false,
  new_ticket_id: null,
  new_ticket_dedicated: null,
};

const COMMENT_FORMAT = {
  BBCODE: 'bbcode',
  PLAIN: 'plain',
};

const DEFAULT_PAGE_SIZES = [10, 25, 50];

const DEVICES_PAGINATION: PaginationOptions = {
  defaultItemsPerPage: 10,
  stateKey: 'devices',
  pageSizes: [10, 25, 50],
};

const INPUT_REQUEST_DEBOUNCE = 600;

const PERMISSION_TAGS = {
  DEVICES_SUPPORTED: 'devices:supported',
  DEVICES_MANDATORY: 'devices:mandatory',
  TEMPLATES_SUPPORTED: 'templates:supported',
  PRODUCT_RAS: 'product:ras',
};

const POLLING_MAX_RETRIES = 120;

const REACH_TEMPLATES = [
  'cbslimitincrease',
  'cdnhttps',
  'ramandserverlimitincrease',
  'ramlimitincrease',
  'serverdiscount',
  'serverlimitincrease',
];

const MOBILE_NAMES = [
  'Android',
  'webOS',
  'iPhone',
  'iPad',
  'BlackBerry',
  'Windows Phone',
];
const MODAL_STATES = {
  ERROR: 'ERROR',
  INITIAL: 'INITIAL',
  SUCCESS: 'SUCCESS',
};

const SELECTED_DEVICES_PAGINATION: PaginationOptions = {
  defaultItemsPerPage: 10,
  stateKey: 'selectedDevices',
  pageSizes: [10, 25, 50],
};

const TEMPLATE_IDS = [
  'serverlimitincrease',
  'ramlimitincrease',
  'serverdiscount',
  'ramandserverlimitincrease',
  'cbslimitincrease',
  'cdnhttps',
];

const TICKETS_PAGINATION: PaginationOptions = {
  defaultItemsPerPage: 25,
  stateKey: 'tickets',
  pageSizes: [10, 25, 50],
};

const TOAST_TIMEOUT = 12000;

const TICKETLIST_TICKETDETAILS_COMMON_PROPERTIES = ['subject', 'status'];
const CLOUD_ONLY_COMMON_PROPERTIES = ['classification', 'severity'];
const TICKETLIST_MODIFIED_PROPERTY = 'modified';

const USER_BROWSER_DETAILS = {
  browserDetails: 'Browser details',
  browserDimensions: 'Browser dimensions',
  deviceDetails: 'Device details',
};

const FEEDBACK_RATING_ARRAY = [
  { label: 'csatSurvey:veryDissatisfied', value: 'Very Dissatisfied' },
  { label: 'csatSurvey:dissatisfied', value: 'Dissatisfied' },
  { label: 'csatSurvey:neutral', value: 'Neutral' },
  { label: 'csatSurvey:satisfied', value: 'Satisfied' },
  { label: 'csatSurvey:verySatisfied', value: 'Very Satisfied' },
];

const FEEDBACK_CHOICES = [
  { label: 'csatSurvey:resResTime', value: 'Response/Resolution Time' },
  { label: 'csatSurvey:proactiveness', value: 'Proactiveness/Ownership' },
  { label: 'csatSurvey:communication', value: 'Communication' },
  { label: 'csatSurvey:technicalExpertise', value: 'Technical Expertise' },
  { label: 'csatSurvey:other', value: 'Other' },
];

const LATEST_TICKET_DETAILS = {
  TicketId: 'Latest Ticket ID',
};

const TICKET_TEMPLATE_GUIDE = {
  TicketTemplateGuide:
    'https://docs.rackspace.com/support/how-to/rackspace-fabric/',
};

const SOLUTIONS_DASHBORAD_URL =
  'https://manage.rackspace.com/dashboard/?status=Active';

const CUSTOMER_ICON_SVG = `
<svg width="30px" height="31px" viewBox="0 0 30 31" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>Icon person</title>
  <g id="🔷-Details-Comments" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Icon-person">
        <path d="M0,15 C0,23.285625 6.71625,30 15,30 C23.28375,30 30,23.285625 30,15 C30,6.714375 23.28375,0 15,0 C6.71625,0 0,6.714375 0,15 Z" id="Stroke-1" fill="#6CA3E1"></path>
        <circle id="Oval" fill="#FFFFFF" cx="15" cy="11.325" r="5.625"></circle>
        <path d="M14.976,16.9 C20.153,16.9 24.351,21.098 24.351,26.275 L24.351,26.735 C21.783,28.794 18.523,30.025 14.976,30.025 C11.428,30.025 8.168,28.794 5.6,26.735 L5.601,26.275 C5.601,21.098 9.799,16.9 14.976,16.9" id="Fill-1" fill="#FFFFFF"></path>
    </g>
  </g>
</svg>
`;

const RACKER_ICON_SVG = `
<svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>Icon racl</title>
  <g id="🔷-Details-Comments" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Icon-racl">
      <circle id="Oval" fill="#212121" cx="15" cy="15" r="15"></circle>
        <g id="Rackspace_Icon_White" transform="translate(7.000000, 5.000000)" fill="#FFFFFF" fill-rule="nonzero">
            <path d="M6.76144183,19.2249806 L6.73934191,19.3411024 L6.48365396,19.3411024 L6.35827664,20 L6.23205488,20 L6.3574322,19.3411135 L6.10046648,19.3411135 L6.1225664,19.2249917 L6.76144183,19.2249806 Z M7.70721613,19.2249806 L7.55975001,20 L7.43352825,20 L7.53677231,19.4574131 L7.22211791,19.8250895 L7.14674041,19.8250895 L6.97219661,19.4563353 L6.86876366,20 L6.74253079,20 L6.89000802,19.2249806 L7.00397427,19.2249806 L7.21414016,19.6689234 L7.59302766,19.2249806 L7.70721613,19.2249806 Z M7.91117094,4.70377842 L8.72065685,0.443227401 L3.71954189,0.443227401 L0,20 L5.67960136,20 L7.21325128,11.9365074 C8.11753685,7.18166931 10.8455157,5.27894297 14.7277237,5.86671859 L15.836864,0.0334066847 C12.4652406,-0.277392675 9.27290059,1.60375696 7.91117094,4.70377842 L7.91117094,4.70377842 Z" id="Shape"></path>
        </g>
      </g>
  </g>
</svg>
`;

const MAINTENANCE_URL = '#';

const SCREEN_SIZE_768 = 768;

const CANCEL_BUTTON_ID = 'cancel-btn';

const PRIVACY_STATEMENT_URL =
  'https://www.rackspace.com/information/legal/privacystatement';
const TERMS_URL = 'https://www.rackspace.com/information/legal/websiteterms';

const DRAWER_TYPES = {
  NONE: '',
  TICKET_DETAILS: 'TICKET_DETAILS',
  CLOSE_TICKET: 'CLOSE_TICKET',
  ADD_RECIPIENT: 'ADD_RECIPIENT',
  ADD_GROUP: 'ADD_GROUP',
  FILTER: 'FILTER',
};

const NOT_A_MOBILE = 'Not a mobile device';

const DEV_SUPPORT_CENTER_URL = 'https://dev.manage.rackspace.com/support/';

const SUPPORT_CENTER_URL = 'https://manage.rackspace.com/support/';

const RESOURCE_ID_FILTER = 'resourceID';

const ADD_PARAM = 'add';

const REMOVE_PARAM = 'remove';

const SESSION_EMAIL_KEY = 'urn:oid:1.2.840.113549.1.9.1.1';

export {
  ACCOUNT_EXCLUSION_TYPES,
  ADD_PARAM,
  BROWSER_NAMES,
  COLLECTIONS,
  COMMENT_FORMAT,
  DEFAULT_NEW_TICKET_QUERYPARAMS,
  DEFAULT_PAGE_SIZES,
  DEVICES_PAGINATION,
  DRAWER_TYPES,
  INPUT_REQUEST_DEBOUNCE,
  MOBILE_NAMES,
  MODAL_STATES,
  PERMISSION_TAGS,
  PILOT_DIV_ID,
  POLLING_MAX_RETRIES,
  REACH_TEMPLATES,
  REMOVE_PARAM,
  RESOURCE_ID_FILTER,
  SELECTED_DEVICES_PAGINATION,
  TEMPLATE_IDS,
  TICKETS_PAGINATION,
  TOAST_TIMEOUT,
  TICKETLIST_TICKETDETAILS_COMMON_PROPERTIES,
  CLOUD_ONLY_COMMON_PROPERTIES,
  TICKETLIST_MODIFIED_PROPERTY,
  USER_BROWSER_DETAILS,
  NONE_SELECTED,
  NOT_A_MOBILE,
  CTUI,
  NPST,
  NPS_RELATED_EVENT_TYPES,
  NPS_RELATED_EVENT_CATEGORIES,
  CSAT_EVENT_TYPES,
  CSAT_EVENT_CATEGORIES,
  CSAT,
  LATEST_TICKET_DETAILS,
  KEVALIN_COLLECTIONS,
  TICKET_TEMPLATE_GUIDE,
  RACKER_ICON_SVG,
  CUSTOMER_ICON_SVG,
  MAINTENANCE_URL,
  FEEDBACK_RATING_ARRAY,
  FEEDBACK_CHOICES,
  SCREEN_SIZE_768,
  CANCEL_BUTTON_ID,
  PRIVACY_STATEMENT_URL,
  TERMS_URL,
  DEV_SUPPORT_CENTER_URL,
  SESSION_EMAIL_KEY,
  SUPPORT_CENTER_URL,
  SOLUTIONS_DASHBORAD_URL,
};
